module.exports = __webpack_public_path__ + "img/login_logo_new.16908c07.png";